import { Observable } from 'rxjs';
import { PrecheckinStep1Repository } from '../repository/precheckin-step1.repository';
import { UseCase } from '@/core/base/use-case';

export class GetPrecheckinUseCase implements UseCase<any, any> {
    constructor(private readonly repository: PrecheckinStep1Repository) {}

    execute(): Observable<any> {
        return this.repository.getPrecheckin();
    }
}
